import { render, staticRenderFns } from "./ProxyComponent.vue?vue&type=template&id=5e1b0b34"
import script from "./ProxyComponent.ts?vue&type=script&lang=ts&external"
export * from "./ProxyComponent.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports